import React, { useEffect } from 'react'
import { useDrupalApi } from '../local'

/**
 * @typedef {Object} GlobalActionsDispatcherProps
 * @property {Element|JSX.Element} children
 */

/**
 * Component responsible of application global actions initialization.
 * @param {GlobalActionsDispatcherProps} props
 * @return {JSX.Element}
 */
export function GlobalActionsDispatcher({ children }) {
  const isStorybook = `${process.env.STORYBOOK}` === 'yes'
  const { acquireDrupalToken } = useDrupalApi()
  useEffect(() => {
    if (!isStorybook) {
      acquireDrupalToken().then(() => console.log('Negotiated acquisition of Drupal CSRF token.'))
    }
  }, [])

  return <>{children}</>
}
